import React from "react";
import { Card } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import PanelLoadingIndicator from "../PanelLoadingIndicator";

const useStyles = makeStyles(theme => ({
  root: {
    width: 300,
    height: 115,
    backgroundColor: theme.palette.background.default,
    color: theme.palette.primary.main,
    borderRadius: 20,
    padding: 20,
  },
}));

const ReportLoadingIndicator = ({ primary, secondary, count }) => {
  const classes = useStyles();

  return (
    <Card classes={{ root: classes.root }}>
      <PanelLoadingIndicator />
    </Card>
  );
};

export default ReportLoadingIndicator;
